import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Output,
  EventEmitter,
} from '@angular/core'

@Directive({
  standalone: false,
  selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
  constructor(private _elementRef: ElementRef) {}

  @Output() appClickOutside = new EventEmitter<any>()

  @HostListener('document:click', ['$event.target']) onMouseEnter(
    targetElement,
  ) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement)
    if (!clickedInside) {
      this.appClickOutside.emit(null)
    }
  }
}
